import { render } from "./VmsSidebarCamerasTabFiltersCameraGroup.vue?vue&type=template&id=54c996e5&ts=true"
import script from "./VmsSidebarCamerasTabFiltersCameraGroup.vue?vue&type=script&lang=ts"
export * from "./VmsSidebarCamerasTabFiltersCameraGroup.vue?vue&type=script&lang=ts"

import "./VmsSidebarCamerasTabFiltersCameraGroup.vue?vue&type=style&index=0&id=54c996e5&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__